module.exports = __webpack_public_path__ + "40e26f94c99e11333b740c2d20e83805.svg";